// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VehicleMonitoringTable_card__a-7Sw {
    border-radius: 12px;
    z-index: 1;
    padding: 8px 10px;
    background-color: #ffffff;
}

/* =========================================
   CARD HEADER
========================================= */

.VehicleMonitoringTable_cardHeader__LEVo2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}

.VehicleMonitoringTable_titleWrap__ibtMl {
    display: flex;
    align-items: center;
    gap: 8px;
}

.VehicleMonitoringTable_titleBar__Uoyyb {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: var(--primary-blue-theme-color);
    display: inline-block;
}

.VehicleMonitoringTable_title__rujaA {
    font-size: 15px;
    font-weight: 700;
    color: #26384a;
}

.VehicleMonitoringTable_countBadgeHeader__WeWcJ {
    background-color: #eef2f6;
    color: #6c757d;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 10px;
}

.VehicleMonitoringTable_downloadBtn__GKa\\+5 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: none;
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;
    cursor: pointer;
    transition: opacity 0.15s ease;
}

.VehicleMonitoringTable_downloadBtn__GKa\\+5:hover {
    opacity: 0.85;
}

/* =========================================
   TABLE WRAPPER
========================================= */

.VehicleMonitoringTable_tableWrapper__1An5f {
    width: 100%;
    overflow-x: auto;
    border-radius: 8px;
    max-height: 260px;
    min-height: 120px;
    overflow-y: scroll;
}

.VehicleMonitoringTable_mainTable__lMmK5 {
    width: 100%;
    min-width: 1100px;
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

/* =========================================
   HEADER
========================================= */

.VehicleMonitoringTable_mainTable__lMmK5 thead th {
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    /* same header height as the Device Transmission table (30px hour header) */
    box-sizing: content-box;
    height: 30px;
    padding: 0 8px;
    position: sticky;
    top: 0;
    z-index: 2;
}

.VehicleMonitoringTable_sortableTh__CZgco {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.VehicleMonitoringTable_sortableTh__CZgco:hover {
    background-color: color-mix(in srgb, var(--primary-blue-theme-color) 85%, black);
}

.VehicleMonitoringTable_thContent__qQZfH {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.VehicleMonitoringTable_sortIcon__sxXyN {
    display: inline-flex;
    align-items: center;
    opacity: 0.85;
}

/* =========================================
   BODY / ROWS
========================================= */

.VehicleMonitoringTable_mainTable__lMmK5 tbody td {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    padding: 4px 8px;
}

.VehicleMonitoringTable_dataRow__8RVty {
    transition: background-color 0.2s ease;
}

.VehicleMonitoringTable_dataRow__8RVty td {
    background-color: #ffffff;
}

.VehicleMonitoringTable_dataRow__8RVty:hover td {
    background-color: #f8fbff;
}

.VehicleMonitoringTable_vehicleCell__xlaJv {
    text-align: left !important;
    font-weight: 700;
    color: var(--primary-blue-theme-color);
    white-space: nowrap;
}

.VehicleMonitoringTable_vehicleCell__xlaJv:hover {
    text-decoration: underline;
}

.VehicleMonitoringTable_actionCell__LkRWS {
    color: var(--primary-blue-theme-color);
    font-weight: 500;
    white-space: nowrap;
}

/* =========================================
   STATUS DOT
========================================= */

.VehicleMonitoringTable_statusWrap__-ncB8 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.VehicleMonitoringTable_statusDot__TcUux {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
}

.VehicleMonitoringTable_dot_red__1-kNX {
    background-color: #e5384d;
}

.VehicleMonitoringTable_dot_orange__nnA\\+y {
    background-color: #f5a623;
}

.VehicleMonitoringTable_dot_green__WNzVd {
    background-color: #2ecc71;
}

.VehicleMonitoringTable_dot_grey__gT9RX {
    background-color: #aeb8c1;
}

/* =========================================
   LOADING
========================================= */

.VehicleMonitoringTable_loadingState__K5rT- {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 18px;
    color: #6c757d;
    font-size: 12px;
}

.VehicleMonitoringTable_spinner__Bbgjh {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid #dee2e6;
    border-top-color: var(--primary-blue-theme-color);
    animation: VehicleMonitoringTable_spin__AonbD 0.7s linear infinite;
}

@keyframes VehicleMonitoringTable_spin__AonbD {
    to {
        transform: rotate(360deg);
    }
}

/* =========================================
   MOBILE
========================================= */

@media (max-width: 768px) {
    .VehicleMonitoringTable_tableWrapper__1An5f {
        min-height: 250px;
        max-height: 320px;
    }

    .VehicleMonitoringTable_mainTable__lMmK5 {
        min-width: 950px;
    }

    .VehicleMonitoringTable_mainTable__lMmK5 thead th {
        font-size: 11px;
        padding: 0 8px;
    }

    .VehicleMonitoringTable_mainTable__lMmK5 tbody td {
        font-size: 11px;
        padding: 6px 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/DeviceHealth/VehicleMonitoringTable.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,iDAAiD;IACjD,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iDAAiD;IACjD,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;2CAE2C;;AAE3C;IACI,iDAAiD;IACjD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,2EAA2E;IAC3E,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iDAAiD;IACjD,kEAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".card {\n    border-radius: 12px;\n    z-index: 1;\n    padding: 8px 10px;\n    background-color: #ffffff;\n}\n\n/* =========================================\n   CARD HEADER\n========================================= */\n\n.cardHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 6px;\n}\n\n.titleWrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.titleBar {\n    width: 4px;\n    height: 18px;\n    border-radius: 2px;\n    background-color: var(--primary-blue-theme-color);\n    display: inline-block;\n}\n\n.title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #26384a;\n}\n\n.countBadgeHeader {\n    background-color: #eef2f6;\n    color: #6c757d;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 10px;\n    border-radius: 10px;\n}\n\n.downloadBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: none;\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n}\n\n.downloadBtn:hover {\n    opacity: 0.85;\n}\n\n/* =========================================\n   TABLE WRAPPER\n========================================= */\n\n.tableWrapper {\n    width: 100%;\n    overflow-x: auto;\n    border-radius: 8px;\n    max-height: 260px;\n    min-height: 120px;\n    overflow-y: scroll;\n}\n\n.mainTable {\n    width: 100%;\n    min-width: 1100px;\n    margin-bottom: 0;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n/* =========================================\n   HEADER\n========================================= */\n\n.mainTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap;\n    /* same header height as the Device Transmission table (30px hour header) */\n    box-sizing: content-box;\n    height: 30px;\n    padding: 0 8px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n}\n\n.sortableTh {\n    cursor: pointer;\n    user-select: none;\n}\n\n.sortableTh:hover {\n    background-color: color-mix(in srgb, var(--primary-blue-theme-color) 85%, black);\n}\n\n.thContent {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.sortIcon {\n    display: inline-flex;\n    align-items: center;\n    opacity: 0.85;\n}\n\n/* =========================================\n   BODY / ROWS\n========================================= */\n\n.mainTable tbody td {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n    padding: 4px 8px;\n}\n\n.dataRow {\n    transition: background-color 0.2s ease;\n}\n\n.dataRow td {\n    background-color: #ffffff;\n}\n\n.dataRow:hover td {\n    background-color: #f8fbff;\n}\n\n.vehicleCell {\n    text-align: left !important;\n    font-weight: 700;\n    color: var(--primary-blue-theme-color);\n    white-space: nowrap;\n}\n\n.vehicleCell:hover {\n    text-decoration: underline;\n}\n\n.actionCell {\n    color: var(--primary-blue-theme-color);\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n/* =========================================\n   STATUS DOT\n========================================= */\n\n.statusWrap {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.statusDot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.dot_red {\n    background-color: #e5384d;\n}\n\n.dot_orange {\n    background-color: #f5a623;\n}\n\n.dot_green {\n    background-color: #2ecc71;\n}\n\n.dot_grey {\n    background-color: #aeb8c1;\n}\n\n/* =========================================\n   LOADING\n========================================= */\n\n.loadingState {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 18px;\n    color: #6c757d;\n    font-size: 12px;\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 2px solid #dee2e6;\n    border-top-color: var(--primary-blue-theme-color);\n    animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* =========================================\n   MOBILE\n========================================= */\n\n@media (max-width: 768px) {\n    .tableWrapper {\n        min-height: 250px;\n        max-height: 320px;\n    }\n\n    .mainTable {\n        min-width: 950px;\n    }\n\n    .mainTable thead th {\n        font-size: 11px;\n        padding: 0 8px;\n    }\n\n    .mainTable tbody td {\n        font-size: 11px;\n        padding: 6px 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `VehicleMonitoringTable_card__a-7Sw`,
	"cardHeader": `VehicleMonitoringTable_cardHeader__LEVo2`,
	"titleWrap": `VehicleMonitoringTable_titleWrap__ibtMl`,
	"titleBar": `VehicleMonitoringTable_titleBar__Uoyyb`,
	"title": `VehicleMonitoringTable_title__rujaA`,
	"countBadgeHeader": `VehicleMonitoringTable_countBadgeHeader__WeWcJ`,
	"downloadBtn": `VehicleMonitoringTable_downloadBtn__GKa+5`,
	"tableWrapper": `VehicleMonitoringTable_tableWrapper__1An5f`,
	"mainTable": `VehicleMonitoringTable_mainTable__lMmK5`,
	"sortableTh": `VehicleMonitoringTable_sortableTh__CZgco`,
	"thContent": `VehicleMonitoringTable_thContent__qQZfH`,
	"sortIcon": `VehicleMonitoringTable_sortIcon__sxXyN`,
	"dataRow": `VehicleMonitoringTable_dataRow__8RVty`,
	"vehicleCell": `VehicleMonitoringTable_vehicleCell__xlaJv`,
	"actionCell": `VehicleMonitoringTable_actionCell__LkRWS`,
	"statusWrap": `VehicleMonitoringTable_statusWrap__-ncB8`,
	"statusDot": `VehicleMonitoringTable_statusDot__TcUux`,
	"dot_red": `VehicleMonitoringTable_dot_red__1-kNX`,
	"dot_orange": `VehicleMonitoringTable_dot_orange__nnA+y`,
	"dot_green": `VehicleMonitoringTable_dot_green__WNzVd`,
	"dot_grey": `VehicleMonitoringTable_dot_grey__gT9RX`,
	"loadingState": `VehicleMonitoringTable_loadingState__K5rT-`,
	"spinner": `VehicleMonitoringTable_spinner__Bbgjh`,
	"spin": `VehicleMonitoringTable_spin__AonbD`
};
export default ___CSS_LOADER_EXPORT___;
